import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactMarkdown from 'react-markdown';

const propTypes = {
  title: PropTypes.string.isRequired,
  titleId: PropTypes.string,
  content: PropTypes.string,
};

const defaultProps = {
  content: null,
  titleId: 'common.instructions',
};

const InstructionText = ({ title, titleId, content }) => {
  if (!content) { return null; }

  return (
    <div className="row">
      <div className="margin-top-30 col-xs-10 col-xs-offset-1 col-md-12 col-md-offset-0 padding-0">
        <div className="text-color-dark-slate text-size-xs-16 text-size-md-24 text-weight-bold">
          <FormattedMessage id={titleId} defaultMessage={title} />
        </div>
        <ReactMarkdown
          source={content}
          className="text-color-slate text-size-xs-12 text-size-md-16 margin-top-10"
        />
      </div>
    </div>
  );
};

InstructionText.propTypes = propTypes;
InstructionText.defaultProps = defaultProps;

export default InstructionText;
